import {
  ActionButtonProps,
  Box,
  ColorOptions,
  Form,
  Icon,
  LoaderNew,
  ModBox,
  ModalDialog,
  SpacerNew,
  Text,
} from '@jfs/ui-new'
import { ButtonNew } from '../../../../components/AdminButton'
import { useEffect, useState } from 'react'
import { ScrollView } from 'react-native'
import { EmType } from '../..'
import { RootStore, useLazyApiData, useStores } from '../../../../data/store'
import { MessageTypes } from '../../../../utils'
import EmiFileUpload from '../../../EmiFileUpload'
import { SelectParentEntityList } from '../CreateEntity/SelectParentEntityList'
import { MultipleDocsView } from './MultipleDocsView'
import { DocumentationView } from './View'
import {
  adFlexMap,
  adHeaderData,
  createSubGrpHeader,
  documentationForm,
  flexMapperCreateSubGrp,
  flexMapperKycDocs,
  headerData,
  subGroupDoc,
  subGroupDocFlexMap,
  uploadFlexMap,
} from './form'

interface DocumentationProp {
  type: string
  isValidToProceed: (isValid: boolean) => void
  selectedEntity: any
  showTitle?: boolean
}

const FormBox = ({ children }: any) => {
  return <Box>{children}</Box>
}

const getForm = (getLovsFromKey: any, dateOfExpiry) => {
  return documentationForm(true, <Icon id={'CALENDAR'} size={16} color="PRIMARY" />, getLovsFromKey, dateOfExpiry)
}

const Documentation = ({ type, isValidToProceed, selectedEntity, showTitle = true }: DocumentationProp) => {
  const {
    getDocuments,
    deleteDocument,
    addDocument,
    documentsLength,
    getDocumentsList,
    kycDocumentsList,
    uploadId,
    getLovsFromKey,
    fetchAllLovs,
    deleteKycDoc,
    clearDocuments,
    fetchKycDocCategories,
    searchFilterBy,
  } = useStores((store) => ({
    getDocuments: store.getDocuments,
    deleteDocument: store.deleteDocument,
    addDocument: store.addDocument,
    documentsLength: store.documents.length,
    getDocumentsList: store.getDocumentsList,
    kycDocumentsList: store.kycDocumentsList,
    uploadId: store.onboarding.uploadId,
    getLovsFromKey: store.getLovsFromKey,
    fetchAllLovs: store.fetchAllLovs,
    deleteKycDoc: store.deleteKycDoc,
    clearDocuments: store.clearDocuments,
    fetchKycDocCategories: store.fetchKycDocCategories,
    searchFilterBy: store.onboarding.searchFilterBy,
  }))
  const [fetchDocumentList, fetchDocumentListHandler] = useLazyApiData(getDocumentsList)
  const [fetchKycDocsList, fetchKycDocsHandler] = useLazyApiData(kycDocumentsList)
  const [fetchDeleteKycDoc, deleteKycDocHandler] = useLazyApiData(deleteKycDoc)
  const [lazyFetchKycDocCategories, fetchKycDocCategoriesHandler] = useLazyApiData(fetchKycDocCategories)
  const [showUploadModal, setShowUploadModal] = useState(false)
  const [showDocViewModal, setShowDocViewModal] = useState(false)
  const [isFormValid, setIsFormValid] = useState(false)
  const [selectedDocument, setSelectedDocument] = useState(null)
  const [formValues, setFormValues] = useState({
    NAME: '',
    MERCHANT_DOCUMENT_TYPE: '',
    MERCHANT_DOCUMENT_NAME: '',
    RID: '',
    expiry: '',
    deleteOnly: 'deleteOnly',
    docId: '',
  })
  const [listCalled, setListCalled] = useState(false)
  const [docListCalled, setDocListCalled] = useState(false)
  const [fileExtension, setFileExtension] = useState('')

  useEffect(() => {
    clearDocuments()
    if (type !== 'AD_CHECKER' && type !== 'AD_MAKER' && type === EmType.Search) {
      lazyFetchKycDocCategories({ kycId: 'ALL' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (fetchKycDocCategoriesHandler?.state === 'fulfilled' && !docListCalled) {
      fetchDocumentList(selectedEntity?.[0]?.id ?? selectedEntity?.[0]?.identificationNumber, false, false, type)
      setDocListCalled(true)
    }
  }, [docListCalled, fetchDocumentList, fetchKycDocCategoriesHandler?.state, selectedEntity, type])

  useEffect(() => {
    if (!docListCalled) {
      if (selectedEntity?.[0]?.id || selectedEntity?.[0]?.identificationNumber) {
        fetchDocumentList(selectedEntity?.[0]?.id ?? selectedEntity?.[0]?.identificationNumber, false, false, type)
        setDocListCalled(true)
      } else if (selectedEntity?.id || selectedEntity?.identificationNumber) {
        //Avoiding call here as we are calling it in aadhar redaction search press
        if (type !== 'AD_MAKER') {
          fetchDocumentList(
            selectedEntity?.id ?? selectedEntity?.identificationNumber,
            type === 'AD_MAKER',
            false,
            type,
          )
          setDocListCalled(true)
        }
      } else if (selectedEntity?.uploadId && selectedEntity?.uploadId?.length > 0) {
        fetchKycDocsList(selectedEntity?.uploadId, selectedEntity?.requestType, 'ACTIVE')
        setDocListCalled(true)
      }
    }
  }, [docListCalled, fetchDocumentList, fetchKycDocsList, selectedEntity, type])

  useEffect(() => {
    if (documentsLength > 0) {
      isValidToProceed(true)
    } else {
      isValidToProceed(false)
    }
  }, [documentsLength, isValidToProceed])

  const onDeleteRow = (item: any) => {
    if (type === 'AD_MAKER') {
      fetchDeleteKycDoc(uploadId, item?.TRANSACTION_ID, 'REDACT', item?.MERCHANT_DOCUMENT_TYPE)
    } else {
      deleteDocument(item, type)
    }
  }

  const onItemPress = (item: any) => {
    if (type === 'AD_MAKER') {
      if (item?.DOCUMENTSTATUS === 'REPLACED') {
        RootStore.message.setMessage(
          'You cannot replace already replaced file, kindly delete and retry',
          MessageTypes.INFO,
        )
      } else {
        if (item?.NAME?.includes('.')) {
          setFileExtension(`.${item?.NAME?.toLowerCase()?.split('.')?.[1]}`)
        }
        setListCalled(false)
        setFormValues({
          NAME: item?.NAME,
          MERCHANT_DOCUMENT_TYPE: item?.MERCHANT_DOCUMENT_TYPE,
          MERCHANT_DOCUMENT_NAME: item?.MERCHANT_DOCUMENT_NAME ?? '',
          RID: item?.TRANSACTION_ID,
          expiry: '',
          deleteOnly: '',
          docId: item?.docId,
        })
        setShowDocViewModal(true)
        setSelectedDocument(item)
      }
    } else {
      setShowDocViewModal(true)
      setSelectedDocument(item)
    }
  }

  const actionButtons = ({ values, isCurrentFormValid }: ActionButtonProps) => {
    if (formValues?.NAME !== values?.NAME || formValues?.MERCHANT_DOCUMENT_TYPE !== values?.MERCHANT_DOCUMENT_TYPE) {
      if (isCurrentFormValid && !listCalled) {
        setFormValues({
          NAME: values?.NAME,
          MERCHANT_DOCUMENT_TYPE: values?.MERCHANT_DOCUMENT_TYPE,
          MERCHANT_DOCUMENT_NAME: values?.MERCHANT_DOCUMENT_NAME,
          RID: '', //values?.RID,
          expiry: '', //values?.expiry,
          deleteOnly: 'deleteOnly',
          docId: values?.TRANSACTION_ID,
          status: '',
        })
      }
    }
    setIsFormValid(isCurrentFormValid)
  }
  const handleUpload = () => {
    setShowUploadModal(true)
    setListCalled(false)
  }

  const onReviewPressed = (_val: boolean) => {}

  const onUpdateUploadedExcelFile = (data: any) => {
    if (documentsLength > 0) {
      isValidToProceed(true)
    }
    if (data) {
      setShowDocViewModal(false)
    }
    if (
      (type === EmType.createGroup ||
        type === EmType.createSubGroup ||
        type === EmType.createSingleEntity ||
        type === EmType.applicationQueue ||
        type === EmType.myQueue ||
        type === 'AD_MAKER') &&
      !listCalled
    ) {
      if (type === EmType.createSubGroup) {
        setFormValues({
          NAME: '',
          MERCHANT_DOCUMENT_TYPE: '',
          MERCHANT_DOCUMENT_NAME: '',
          RID: '',
          expiry: '',
          deleteOnly: 'deleteOnly',
          docId: '',
          status: '',
        })
      }
      if (uploadId?.length > 0) {
        setListCalled(true)
        if (type !== 'AD_MAKER') {
          fetchKycDocsList(uploadId, type, 'ACTIVE')
        }
        setTimeout(() => {
          setShowUploadModal(false)
        }, 500)
      }
    }
  }
  const onUpdateFileName = (_fileName: any) => {}
  const onBackPress = () => {
    setShowDocViewModal(false)
  }

  const onReplace = (item: any) => {
    console.log('onReplace item: ', item)
    setShowDocViewModal(false)
    setShowUploadModal(true)
  }

  const applicationStatus = Array.isArray(selectedEntity)
    ? selectedEntity?.[0]?.applicationStatus
    : selectedEntity?.applicationStatus
  const docsList = getDocuments(type, applicationStatus)

  const onDismiss = () => {
    setShowUploadModal(false)
  }

  return (
    <>
      <ModBox
        backgroundColor={'WHITE'}
        w={'100%'}
        h={'100%'}
        show={
          deleteKycDocHandler?.state === 'pending' ||
          fetchDocumentListHandler?.state === 'pending' ||
          fetchKycDocsHandler?.state === 'pending'
        }>
        <LoaderNew color={'PRIMARY'} type={'small'} />
      </ModBox>
      <ModBox nativeID="vertical-scroll" f={1} overflow={'auto'} ph={40} pv={40} backgroundColor={'WHITE'} h={'90%'}>
        <ModBox direction="row" w={'100%'} justifyContent={'space-between'}>
          <Box>
            <ModBox show={showTitle}>
              <Text title={'KYC & Documentation'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
            </ModBox>
            <SpacerNew size={8} direction="vertical" />
            <ModBox show={false}>
              <Text
                title={'You can upload your proof documents, KYC documents etc here.'}
                color={'BLACK_75'}
                fontSize={12}
                fontFamily={'jiotype-medium'}
              />
            </ModBox>
          </Box>
        </ModBox>
        <ModBox
          marginTop={32}
          marginHorizontal={-8}
          show={
            type !== EmType.Search && type !== EmType.applicationQueue && type !== 'AD_CHECKER' && type !== 'AD_MAKER'
          }>
          <Form
            formData={getForm(getLovsFromKey, formValues?.expiry)}
            actionButtons={actionButtons}
            initialValues={formValues}
            container={FormBox}
          />
        </ModBox>
        <ModBox
          marginTop={24}
          show={
            type !== EmType.Search && type !== EmType.applicationQueue && type !== 'AD_CHECKER' && type !== 'AD_MAKER'
          }>
          <ButtonNew
            type={'secondary'}
            borderWidth={1}
            height={40}
            title={'Upload Document'}
            borderColor={'#0070B6'}
            onPress={handleUpload}
            disabled={!isFormValid}
            icon={'UPLOAD'}
          />
        </ModBox>
        <ModBox
          show={
            fetchDocumentListHandler?.state === 'fulfilled' ||
            fetchKycDocsHandler?.state === 'fulfilled' ||
            docsList?.length > 0
          }
          marginTop={40}
          borderRadius={4}
          borderWidth={docsList?.length === 0 ? 1 : 0}
          borderColor={'#E0E0E0' as ColorOptions}>
          <ModBox show={docsList?.length === 0} alignItems={'center'} justifyContent={'center'} minHeight={360}>
            <Text
              title="Your uploaded documents will show up here"
              color={'BLACK_75'}
              fontFamily="jiotype-medium"
              fontSize={12}
            />
          </ModBox>
          <ModBox show={docsList?.length > 0}>
            <SelectParentEntityList
              title={''}
              hide={false}
              data={docsList}
              headerTitles={
                type === EmType.Search && searchFilterBy !== 'SubGroup ID'
                  ? headerData
                  : type === EmType.applicationQueue && applicationStatus === 'Completed'
                  ? subGroupDoc
                  : type === 'AD_MAKER'
                  ? adHeaderData
                  : type === EmType.createSubGroup ||
                    (type === EmType.applicationQueue && applicationStatus === 'Pending For Approval')
                  ? createSubGrpHeader
                  : subGroupDoc
              }
              columnFlexMapper={
                type === EmType.Search && searchFilterBy !== 'SubGroup ID'
                  ? flexMapperKycDocs
                  : type === EmType.applicationQueue && applicationStatus === 'Completed'
                  ? subGroupDocFlexMap
                  : type === 'AD_MAKER'
                  ? adFlexMap
                  : type === EmType.createSubGroup ||
                    (type === EmType.applicationQueue && applicationStatus === 'Pending For Approval')
                  ? flexMapperCreateSubGrp
                  : uploadFlexMap
              }
              onDelete={onDeleteRow}
              onItemPress={onItemPress}
              onDownloadPress={onItemPress}
              hideColumnNames={
                type === EmType.Search || (type === EmType.applicationQueue && applicationStatus === 'Completed')
                  ? []
                  : type === 'AD_MAKER'
                  ? []
                  : ['uploadId', 'RID']
              }
            />
          </ModBox>
        </ModBox>
      </ModBox>
      <ModalDialog
        type="CenteredWrap"
        children={
          <ModBox borderRadius={8} bg={'WHITE'} w={600} overflow={'auto'} justifyContent={'center'} align="center">
            <EmiFileUpload
              type={'documentation'}
              title={'Upload file'}
              dropText={'Drop your file here'}
              onReviewPressed={onReviewPressed}
              updateUploadedExcelFile={onUpdateUploadedExcelFile}
              updateFileName={onUpdateFileName}
              fileType={type === 'AD_MAKER' ? fileExtension : '.xls,.xlsx,.xlsb,.doc,.docx,.pdf,.jpg,.jpeg,.png'}
              documentFormData={formValues}
              flowType={type}
              identificationNumber={selectedEntity?.id}
              showRemoveFile={type !== 'AD_MAKER' && type !== EmType.createSubGroup}
              onDismiss={onDismiss}
            />
          </ModBox>
        }
        show={showUploadModal}
        onDismiss={() => setShowUploadModal(false)}
        onClose={() => setShowUploadModal(false)}
      />
      <ModalDialog
        type="CenteredWrap"
        children={
          <ScrollView nestedScrollEnabled contentContainerStyle={{ alignItems: 'flex-start' }}>
            <ModBox show={type === EmType.Search && searchFilterBy !== 'SubGroup ID'}>
              <MultipleDocsView
                item={selectedDocument}
                flowType={type}
                onBackPress={onBackPress}
                entityId={
                  Array.isArray(selectedEntity)
                    ? selectedEntity?.[0]?.identificationNumber || selectedEntity?.[0]?.id
                    : selectedEntity?.id || selectedEntity?.identificationNumber || selectedEntity?.uploadId
                }
              />
            </ModBox>
            <ModBox show={!(type === EmType.Search && searchFilterBy !== 'SubGroup ID')}>
              <DocumentationView
                entityId={
                  Array.isArray(selectedEntity)
                    ? selectedEntity?.[0]?.identificationNumber || selectedEntity?.[0]?.id
                    : selectedEntity?.id || selectedEntity?.identificationNumber || selectedEntity?.uploadId
                }
                documentName={selectedDocument?.NAME ?? ''}
                type={
                  selectedDocument?.NAME?.includes('.pdf') || selectedDocument?.NAME?.includes('.PDF')
                    ? 'PDF'
                    : selectedDocument?.NAME?.includes('.png') || selectedDocument?.NAME?.includes('.PNG')
                    ? 'PNG'
                    : selectedDocument?.NAME?.includes('.jpg') || selectedDocument?.NAME?.includes('.JPG')
                    ? 'JPG'
                    : selectedDocument?.NAME?.includes('.JPEG') || selectedDocument?.NAME?.includes('.jpeg')
                    ? 'JPG'
                    : `${selectedDocument?.NAME?.split('.')?.[1]}`
                }
                onBackPress={onBackPress}
                item={selectedDocument}
                flowType={type}
                onReplacePress={onReplace}
                applicationStatus={applicationStatus}
              />
            </ModBox>
          </ScrollView>
        }
        show={showDocViewModal}
        onDismiss={() => setShowDocViewModal(false)}
        onClose={() => setShowDocViewModal(false)}
      />
    </>
  )
}

export { Documentation }
